export default __webpack_public_path__ + "static/media/credit-card.d5dfcb68.png";